import React from "react";
import * as Steps from './steps/index';

export default function ResultVersionControl({result}) {
  switch(result.version) {
    case "3.1":
      return 
    default:
      return <Steps.Quoter
      productType={"FinalExpense"}
      formState={result.formStatePagesQuoter}
      fullFormState={result.fullFormState}
      basicInfo={result.basicInfo}
      onNext={result.onNext}
      onBack={result.onBack}
      onFieldChange={result.onFieldChange}
      setFormState={result.setFormState}
      onMultiFieldChange={result.onMultiFieldChange}
      setEmailPrefill={result.setEmailPrefill}
      setQuoteEmail={result.setQuoteEmail}
      coverageAmountSpecs={result.coverageAmountSpecs}
    />
  };
}